import blog1 from './assets/blog1.png';
import bilant from './assets/bilant.png';
import cont from './assets/cont.png';
import orange from './assets/orange.png';
import red from './assets/red.png';




const blogPosts = [
  {
    date: '23 mar 2026',
    time: '6 minute',
    title: 'Contul 201 "Cheltuieli de constituire" - tratament contabil complet',
    author: 'De echipa ContaLearn',
    href: '/blog/cont-201-cheltuieli-de-constituire/',
    image: cont,
    featured: true,
  },
  {
    date: '20 aug 2024',
    time: '5 minute',
    title: 'Bilantul contabil explicat simplu, cu exemple practice',
    author: 'De echipa ContaLearn',
    href: '/blog/cum-sa-inveti-contabilitate/',
     image: bilant,
    featured: true,
  },
  {
    date: '17 aug 2024',
    time: '4 minute',
    title: 'Cum intelegi mai rapid activele, pasivele si capitalurile',
    author: 'De echipa ContaLearn',
    href: '/blog/top-5-greseli-incepatori/',
     image: blog1,
  },
  {
    date: '17 aug 2024',
    time: '4 minute',
    title: 'Cum intelegi mai rapid activele, pasivele si capitalurile',
    author: 'De echipa ContaLearn',
    href: '/blog/top-5-greseli-incepatori/',
     image: orange,
  },
  {
    date: '17 aug 2024',
    time: '4 minute',
    title: 'Cum intelegi mai rapid activele, pasivele si capitalurile',
    author: 'De echipa ContaLearn',
    href: '/blog/top-5-greseli-incepatori/',
     image: red,
  },
];

export default blogPosts;